import { Box, Table, Text } from "@chakra-ui/react"
import React from "react"
import { Colors } from "../../../theme/colors"
import { MyFMPTableColGroup, MyFMPTableHeaderRow } from "./myFMPs.compactTable"

interface EmptyInitialStateProps {
  message?: string
  headerBg?: string
}
export const EmptyInitialState: React.FC<EmptyInitialStateProps> = ({ message, headerBg }) => (
  <Box w="100%" overflow="auto">
    <Table w="100%">
      <MyFMPTableColGroup />
      <MyFMPTableHeaderRow headerBg={headerBg} />
    </Table>
    <Text mt="24px" fontSize="18px" fontWeight="600" color={Colors.Secondary.c2} align="center">
      {message ?? "No FMP Data to Display"}
    </Text>
  </Box>
)
